import '../css/register.css';

const RegisterSuccess = ({ onClose }) => {
  return (
    <aside className="register-success p-4">
      <h4 style={{ textAlign: 'center' }}>THÔNG BÁO</h4>
      <b className="mb-2">Bạn đã đăng ký thành công!</b>
      <p>Vui lòng đợi quản trị viên duyệt thông tin đăng ký của bạn.</p>
      <div className="d-flex">
        <button onClick={onClose} className="ms-auto">
          Đóng
        </button>
      </div>
    </aside>
  );
};
export default RegisterSuccess;
